import React from 'react';

export const BrandLoader: React.FC<{ label?: string; compact?: boolean }> = ({ label = 'Loading', compact = false }) => (
  <div className={`intrlock-brand-loader${compact ? ' compact' : ''}`} role="status" aria-live="polite">
    <span className="intrlock-brand-loader-mark" aria-hidden="true" />
    <span className="intrlock-brand-loader-label">{label}</span>
  </div>
);
